module.exports = __webpack_public_path__ + "static/loading.a3146e8d.gif";